import React from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

class Pagination extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageSizes: [5, 10, 15, 20, 25, 50, 100],
            //  pageSize: 5
        }
    }
    componentDidMount = async () => {
        let pageSize = 0;
        if (localStorage.getItem("listingPageSize") != null &&
            localStorage.getItem("listingPageSize") !== undefined && localStorage.getItem("listingPageSize") !== '0') {
            let tempstr = localStorage.getItem("listingPageSize");
            pageSize = parseInt(tempstr);
            this.setState({
                pageSize: pageSize,
            });
        }
        else {

            this.setState({
                pageSize: 5,
            });
        }
    }
    pageSizeChanged(pageSize) {
        this.props.setPageSize(pageSize);
        this.setState({
            pageSize: pageSize
        });
    }

    onPageChanged(page) {
        this.props.setPage(page);
    }

    render() {
        const { pager } = this.props;
        return (
            <div className="row">
                <div className="container-fluid m-0 p-0"  >
                    <div className="row nopadding"  >
                        <div className="form-group  nopadding" style={{ width: '20%', marginLeft: '0%', marginBottom: '0%' }}>
                            <label className="mr-1" style={{ paddingLeft: '5%' }}>Showing  {pager.startIndex + 1} - {pager.endIndex + 1} of {pager.totalItems} Entries</label>
                        </div>
                        <div className="form-group  nopadding " style={{ width: '20%', marginLeft: '10%', marginBottom: '0%' }}>
                            <label className="mr-2">Show</label> <select name="size" value={this.state.pageSize} onChange={(event) => this.pageSizeChanged(event.target.value)}>
                                {this.state.pageSizes.map((pagesize) => (
                                    <option value={pagesize} >{pagesize}</option>
                                ))
                                }
                            </select>
                        </div>
                        <div className="col    " style={{ textAlign: 'right', marginRight: '1%' }}>
                            {pager.pages && pager.pages.length && <div className="btn-group ml-auto" style={{ marginRight: '0%' }}>
                                <ul className=" pagination ">
                                    <li className={classnames('page-item', { disabled: pager.currentPage === 1 })} >
                                        <button type="button" className="page-link" onClick={() => this.onPageChanged(1)} >First</button>
                                    </li>
                                    <li className={classnames('page-item', { disabled: pager.currentPage === 1 })} >
                                        <button type="button" className="page-link" onClick={() => this.onPageChanged(pager.currentPage - 1)} >Previous</button>
                                    </li>
                                    {pager.pages.map((page) => (
                                        <li className={classnames('page-item', { active: pager.currentPage === page })} style={{ backgroundColor: ' #ADD8E6' }} >
                                            <button type="button" className="page-link" onClick={() => this.onPageChanged(page)} >{page}</button>
                                        </li>
                                    ))}

                                    <li className={classnames('page-item', { disabled: pager.currentPage === pager.totalPages })}>
                                        <button type="button" className="page-link" onClick={() => this.onPageChanged(pager.currentPage + 1)} >Next</button>
                                    </li>
                                    <li className={classnames('page-item', { disabled: pager.currentPage === pager.totalPages })}>
                                        <button type="button" className="page-link" onClick={() => this.onPageChanged(pager.totalPages)} >Last</button>
                                    </li>
                                </ul>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default Pagination;
